module.exports = __webpack_public_path__ + "img/erweima1.2f1f9ca3.png";